// de_pms_guests.ts
// Tłumaczenia dla PMS.Guests.tsx

export const dePmsGuests = {

  title:       "Gaeste",
  addGuest:    "Gast hinzufuegen",
  adding:      "Hinzufuegen...",
  backToGuests:"Zurueck zu Gaesten",

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    name:          "Vollstaendiger Name",
    email:         "E-Mail",
    phone:         "Telefon",
    country:       "Land",
    address:       "Adresse",
    arrivalTime:   "Ankunftszeit",
    arrival:       "Anreise",
    departure:     "Abreise",
    adultsChildren:"Erwachsene / Kinder",
    balanceDue:    "Offener Betrag",
    billingCompany:"Rechnungsfirma",
    activeFolio:   "Aktives Folio",
    actions:       "Aktionen",
  },

  // ── Walidacja ─────────────────────────────────────────────────────────────
  validation: {
    arrivalDeparture:"Anreise und Abreise muessen mindestens eine Nacht umfassen.",
  },

} as const;

export default dePmsGuests;
